<div
  class="modal"
  [ngClass]="{
    'modal--visible': isVisible
  }"
>
  <div class="modal_box">
    <div *ngIf="bigIcon" class="modal_box_icon" [ngClass]="{
      'modal_box_icon--check': bigIcon === 'check',
      'modal_box_icon--dots': bigIcon === 'dots'
    }"></div>

    <div class="modal_titles-container">
        <h4 class="modal_title">{{ title }}</h4>
        <h5 class="modal_subtitle">{{ subtitle }}</h5>
    </div>
    <div class="modal_content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
